import React from "react";
import Button from "react-bootstrap/esm/Button";
import Shape from '../images/Shape.png';
import Rectangle from '../images/Rectangle.png';
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Link } from 'react-router-dom';
import Avatar from '../images/avatar';
import Oval from '../images/Oval.svg';
import Footer from "./reusable-components/footer";

function UserInformation() {
  return (
    <div className="App"
      style={{
        width: '100%',
        height: '753px',
        backgroundColor: '#FFFFFF',
        textAlign: 'center'
      }}>
      <div className="topBar"
        style={{ padding: '13px' }}>
        <img src={Shape} style={{ width: '65px', height: '17px' }} alt="" />
      </div>
      <div >
        <img src={Rectangle} style={{ width: '100%', height: '66px' }} alt="" />
      </div>
      <div style={{
        backgroundColor: '#f9f9f9'
      }}>
        <div
          style={{
            padding: '22px'
          }}>
          <p
            style={{
              font: 'Sintony',
              fontWeight: '700',
              fontSize: '14px',
              textAlign: 'center',
              lineHeight: '18.24px'
            }}>REGISTER WITH IQOS</p>
        </div>
        <div style={{
          fontSize: '12px'
        }}>
          <p>  <img src={Oval} style={{ width: '28px', height: '28px', marginRight: '5px' }} alt="" /> AGE VERIFICATION</p>
        </div>
        <div
          style={{
            padding: '22px',
            textAlign: 'left',
            fontSize: '12px'
          }}>
          <span>MY BIRTHDAY (DD/MM/YYYY)</span>
          <div style={{ marginTop: '5px' }}>
            <input style={{ width: '-webkit-fill-available' }} type="date" id="birthday" name="birthday"></input>
          </div>
          <Form.Group className="mb-3" controlId="formBasicCheckbox" style={{ marginTop: '10px' }}>
            <Form.Check type="checkbox" label="I verify that I am 21 years of age or older" />
          </Form.Group>
        </div>
        <div style={{ fonSize: '12px', fontWeight: 'bold', fontStyle: 'normal', lineHeight: '16px' }}>
          <p>  <img src={Oval} style={{ width: '28px', height: '28px', marginRight: '5px' }} alt="" /> CONTACT INFO</p>
        </div>
        <div
          style={{
            textAlign: 'left',
            marginLeft: '20px',
            marginRight: '20px'
          }}>
          <Form.Group as={Col} md="4" controlId="validationCustom01">
            <Form.Label style={{ fontSize: '11px' }}>FIRST NAME</Form.Label>
            <Form.Control
              required
              size="sm"
              type="text"
              placeholder="First name"
              defaultValue="Adityanand"
            />
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="validationCustom01">
            <Form.Label style={{ fontSize: '11px' }}>LAST NAME</Form.Label>
            <Form.Control
              required
              size="sm"
              type="text"
              placeholder="Last name"
              defaultValue="Singh"
            />
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="validationCustom01">
            <Form.Label style={{ fontSize: '11px' }}>ADDRESS</Form.Label>
            <Form.Control
              required
              type="text"
              placeholder=""
              defaultValue=""
            />
          </Form.Group>
          <Form.Group as={Col} md="6" controlId="validationCustom03">
            <Form.Label style={{ fontSize: '11px' }}>CITY</Form.Label>
            <Form.Control type="text" required />
            <Form.Control.Feedback type="invalid" style={{ fontSize: '11px' }}>
              Please provide a valid city.
            </Form.Control.Feedback>
          </Form.Group>
          <Row>
            <Col>
              <Form.Group as={Col} md="3" controlId="validationCustom04">
                <Form.Label style={{ fontSize: '11px' }}>STATE</Form.Label>
                <Form.Select aria-label="Default select example" style={{ fontSize: '12px' }}>
                  <option>Select</option>
                  <option value="1">California</option>
                  <option value="2">Dallas</option>
                  <option value="3">Texas</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid" style={{ fontSize: '11px' }}>
                  Please provide a valid state.
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} md="3" controlId="validationCustom05">
                <Form.Label style={{ fontSize: '11px' }}>ZIP CODE</Form.Label>
                <Form.Control type="text" placeholder="Zip" size="sm" required />
                <Form.Control.Feedback type="invalid" style={{ fontSize: '11px' }}>
                  Please provide a valid zip.
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label style={{ fontSize: '11px' }}>EMAIL ADDRESS</Form.Label>
            <Form.Control type="email" placeholder="adityanand.singh@merklecxm.com" size="sm" />
          </Form.Group>
        </div>
        <div style={{
          textAlign: 'left',
          marginLeft: '20px'
        }}>
          <span style={{
            color: '#49568',
            fontSize: '11px'
          }}>AVATAR</span>
          <Row>
            <Col>
              <div >
                <img src={Avatar} style={{ width: '90px', height: '110px' }} alt="" />
              </div>
            </Col>
            <Col>
              <div style={{
                marginTop: '20px',
                textAlign: 'left',
                marginLeft: '5px',
                marginRight: '85px'
              }}>
                <Button variant="outline-secondary" size="lg" type="submit" style={{
                  height: '43px',
                  width: '144px',
                  fontSize: '12px',
                  borderRadius: '0'
                }} >
                  UPLOAD AN IMAGE
                </Button>
              </div>
            </Col>
          </Row>
        </div>
        <div style={{
          fontSize: '11px', marginLeft: '20px',
          marginRight: '20px'
        }}>
          <div>
            <p style={{ fontSize: '12px', fontWeight: '600' }}>  <img src={Oval} style={{ width: '28px', height: '28px', marginRight: '5px' }} alt="" /> ABOUT ME</p>
          </div>
          <div
            style={{
              textAlign: 'left',
              fontSize: '11px',
            }}>
            <div style={{
              marginBottom: '10px'
            }}>HOW MANY TIMES PER DAY DO YOU SMOKE?</div>
            <Form.Select aria-label="Default select example" style={{ fontSize: '12px' }}>
              <option >SELECT</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </Form.Select>
          </div>
          <div
            style={{
              textAlign: 'left'
            }}>
            <div style={{
              marginBottom: '10px',
              marginTop: '10px'
            }}>WHAT IS YOUR FAVORITE TOBACCO FLAVOR?</div>
            <Form.Select aria-label="Default select example" style={{ fontSize: '12px' }}>
              <option >SELECT</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </Form.Select>
          </div>
          <div
            style={{
              textAlign: 'left'
            }}>
            <div style={{
              marginBottom: '10px',
              marginTop: '10px'
            }}>LOREM ISPUM DOLER SIT AMENT?</div>
            <Form.Select aria-label="Default select example" style={{ fontSize: '12px' }}>
              <option >SELECT</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </Form.Select>
          </div>
          <div
            style={{
              textAlign: 'left'
            }}>
            <div style={{
              marginBottom: '10px',
              marginTop: '10px'
            }}>LOREM ISPUM DOLER SIT AMENT?</div>
            <Form.Select aria-label="Default select example" style={{ fontSize: '12px' }}>
              <optgroup >
                <option>SELECT</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </optgroup>
            </Form.Select>
          </div>
          <div style={{
            textAlign: 'left',
            marginTop: '20px'
          }}>
            <div style={{
              marginBottom: '10px',
              marginTop: '10px'
            }}>WHAT ARE YOUR FAVORITE THINGS TO DO? <br />
              (SELECT ALL THAT APPLY)</div>
            <Form >
              {['checkbox'].map((type) => (
                <div key={`inline-${type}`} className="mb-3">
                  <Row>
                    <Col>  <Form.Check
                      inline
                      label="Watch the game"
                      name="group1"
                      type={type}
                      id={`inline-${type}-1`}
                    /></Col>
                    <Col> <Form.Check
                      inline
                      label="Hitting the gym"
                      name="group1"
                      type={type}
                      id={`inline-${type}-1`}
                    /></Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Check
                        inline
                        label="Hang out at the bar"
                        name="group1"
                        type={type}
                        id={`inline-${type}-1`}
                      />
                    </Col>
                    <Col>
                      <Form.Check
                        inline
                        label="Catch a wave"
                        name="group1"
                        type={type}
                        id={`inline-${type}-2`}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Check
                        inline
                        label="Shop with friends"
                        name="group1"
                        type={type}
                        id={`inline-${type}-2`}
                      />
                    </Col>
                    <Col>
                      <Form.Check
                        inline
                        label="Play video games"
                        name="group1"
                        type={type}
                        id={`inline-${type}-2`}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Check
                        inline
                        label="Lorem ipsum sim"
                        name="group1"
                        type={type}
                        id={`inline-${type}-2`}
                      />
                    </Col>
                    <Col>
                      <Form.Check
                        inline
                        label="Lorem ipsum sim"
                        name="group1"
                        type={type}
                        id={`inline-${type}-2`}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Check
                        inline
                        label="Lorem ipsum sim"
                        name="group1"
                        type={type}
                        id={`inline-${type}-2`}
                      />
                    </Col>
                    <Col>
                      <Form.Check
                        inline
                        label="Lorem ipsum sim"
                        name="group1"
                        type={type}
                        id={`inline-${type}-2`}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Check
                        inline
                        label="Lorem ipsum sim"
                        name="group1"
                        type={type}
                        id={`inline-${type}-2`}
                      />
                    </Col>
                    <Col>
                      <Form.Check
                        inline
                        label="Lorem ipsum sim"
                        name="group1"
                        type={type}
                        id={`inline-${type}-2`}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Check
                        inline
                        label="Lorem ipsum sim"
                        name="group1"
                        type={type}
                        id={`inline-${type}-2`}
                      />
                    </Col>
                    <Col>
                      <Form.Check
                        inline
                        label="Lorem ipsum sim"
                        name="group1"
                        type={type}
                        id={`inline-${type}-2`}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Check
                        inline
                        label="Lorem ipsum sim"
                        name="group1"
                        type={type}
                        id={`inline-${type}-2`}
                      />
                    </Col>
                    <Col>
                      <Form.Check
                        inline
                        label="Lorem ipsum sim"
                        name="group1"
                        type={type}
                        id={`inline-${type}-2`}
                      />
                    </Col>
                  </Row>
                </div>
              ))}
            </Form>
          </div>
          <div>
            <p>  <img src={Oval} style={{ width: '28px', height: '28px', marginRight: '5px' }} alt="" /> CREATE A PASSWORD</p>
          </div>
          <div
            style={{
              textAlign: 'left',
            }}>
            <Form>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label >PASSWORD</Form.Label>
                <Form.Control size="sm" type="password" placeholder="Password" />
                <Form.Label style={{
                  marginTop: '10px'
                }}>CONFIRM PASSWORD</Form.Label>
                <Form.Control size="sm" type="password" placeholder="Password" />
              </Form.Group>
            </Form>
          </div>
        </div >
        <div
          style={{ padding: '13px' }}>
          <Link to="/Scan">
            <Button variant="success" size="lg" type="submit" style={{
              height: '35px',
              width: '185px',
              fontSize: '12px',
              fontWeight: 'bold',
              borderRadius: '0',
              color: '#FFFFFF',
              backgroundColor: '#00A78A'
            }} >
              SUBMIT REGISTRATION
            </Button>
          </Link>
        </div>
        <div>
          <Footer />
        </div>
      </div>
    </div >
  );
}

export default UserInformation;